import React from 'react'
import IfoImg from "../../../../Assets/Images/cashbox_3.1.png"
import ScreenshotIcon from '@mui/icons-material/Screenshot';
import PaymentsIcon from '@mui/icons-material/Payments';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckCircle';
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
function Prem() {
  return (
    <div className='flex flex-col lg:flex-row sm:ml-8 justify-center lg:space-x-20'>
      <img data-aos="zoom-in-up" alt='Img' className='w-[227px] mb-10 lg:mb-0 mx-auto lg:mx-0 h-[543px]' src={IfoImg} width={227} height={543} />
      <div className='max-w-[685px]'>
        <div data-aos="zoom-in-up" className='text-white text-center lg:text-left mb-10'>
          <strong className='text-[25px] sm:text-[30px]'>АВТОМАТИЗАЦИЯ БИЗНЕСА</strong>
          <p className='text-[13px] sm:text-[18px]'>Контроль (кассиров), формирование управленческих отчетов, статистика продаж за день и за период, статистика продаж по каждому товару в отдельности, ведение складского учета.</p>
        </div>
        <ul data-aos="zoom-in-up"
          data-aos-anchor-placement="center-bottom" className='flex flex-col items-center md:items-start space-y-8'>
          <div className='flex flex-col md:flex-row justify-between space-y-10 md:space-y-0 md:space-x-10'>
            <li className='text-white text-center sm:text-left sm:w-[350px]'>
              <button className='w-[72px] mb-3 h-[72px] mx-auto sm:mx-0 flex items-center justify-center rounded-[50%] bg-[#00C9DB]'>
                <ScreenshotIcon style={{ "inlineSize": "40px", "blockSize": "40px" }} />
              </button>
              <div>
                <strong className='text-[20px] sm:text-[25px]'>СЕНСОРНЫЙ ЭКРАН</strong>
                <p className='text-[13px] sm:text-[18px] mt-1'>Комфортное пользование большим и емкостным IPS дисплеем с диагональю 5,5 дюймов</p>
              </div>
            </li>
            <li className=' text-white text-center sm:text-left sm:w-[350px]'>
              <button className='w-[72px] mx-auto sm:mx-0 mb-3 h-[72px] flex items-center justify-center rounded-[50%] bg-[#00C9DB]'>
                <PaymentsIcon style={{ "inlineSize": "40px", "blockSize": "40px" }} />
              </button>
              <div>
                <strong className='text-[20px] sm:text-[25px]'>ВСЕ ВИДЫ ОПЛАТЫ</strong>
                <p className='text-[13px] sm:text-[18px]'>Пластиковые карты, бесконтактные карты NFC, наличные деньги, мобильные приложения, использование дисконтных магнитных карт.</p>
              </div>

            </li>
          </div>
          <div className='flex flex-col md:flex-row justify-between space-y-10 md:space-y-0 md:space-x-10'>
            <li className='text-white text-center sm:text-left sm:w-[350px]'>
              <button className='w-[72px] mx-auto sm:mx-0 mb-3 h-[72px] flex items-center justify-center rounded-[50%] bg-[#00C9DB]'>
                <PlaylistAddCheckCircleIcon style={{ "inlineSize": "40px", "blockSize": "40px" }} />
              </button>
              <div>
                <strong className='text-[20px] sm:text-[25px]'>ПРАВИЛЬНАЯ ПОСЛЕДОВАТЕЛЬНОСТЬ ДЕЙСТВИЕ КАССИРА</strong>
                <p className='text-[13px] sm:text-[18px] mt-1'>Отсутствие ошибок в расчетах. Кассовый софт автоматически прибавляет, умножает, вычитает, считает сумму чека. При неверной операции программа выдаст сообщение, операция не осуществиться до исправления ошибки</p>
              </div>
            </li>
            <li className=' text-white text-center sm:text-left sm:w-[350px]'>
              <button className='w-[72px] mx-auto sm:mx-0 mb-3 h-[72px] flex items-center justify-center rounded-[50%] bg-[#00C9DB]'>
                <AddHomeWorkIcon style={{ "inlineSize": "40px", "blockSize": "40px" }} />
              </button>
              <div>
                <strong className='text-[20px] sm:text-[25px]'>МОЖЕТ РАБОТАТЬ С ЛЮБЫМ УСТРОЙСТВОМ ФИСКАЛИЗАЦИИ</strong>
                <p className='text-[13px] sm:text-[18px]'>- фискальный модуль в виде sam-карты;
                  <br />
                  - фискальный накопитель по USB подключению</p>
              </div>

            </li>
          </div>
        </ul>
      </div>
    </div>
  )
}

export default Prem